<template>
  <div class="media-library__search">
    <input
        class="media-library__search-input"
        type="text"
        :placeholder="settings.searchPlaceholder"
        v-model="formData.search"
        @keyup="sendSearchString"
    />
    <button class="btn btn-primary">
      <svg id="search" aria-hidden="true" role="presentation" class="icon icon--search"
           xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
        <path
            d="M23.38,19.5a12.64,12.64,0,1,0-3.81,3.85l.57-.4L29.19,32,32,29.14l-9-9ZM19.78,5.6A10,10,0,0,1,12.7,22.7,10,10,0,0,1,5.62,5.6a10,10,0,0,1,14.16,0Z" />
      </svg>
      <span v-html="settings.searchButton" />
    </button>
  </div>
</template>

<script>
import { defineComponent, ref, toRefs } from 'vue';

export default defineComponent({
  name: 'MediaLibrarySearch',
  props: {
    settings: {
      type: Object,
      required: true
    }
  },
  setup(props, { emit }) {
    const { settings } = toRefs(props);
    const formData = ref({
      search: ''
    });

    const sendSearchString = () => {
      emit('searchStringChange', formData.value.search);
    };

    return {
      settings,
      formData,
      sendSearchString
    };
  }
});
</script>
